<template>
  <div class="table-responsive">
    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <table class="table table-hover" v-if="!loading">
      <thead>
        <tr class="border-bottom-primary">
          <th scope="col" v-for="(col, idx) in columns" :key="idx">{{ col.text || col.value }}</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, rowIndex) in rows" :key="rowIndex">
          <td v-for="(col, colIndex) in columns" :key="colIndex">
            <template v-if="isBooleanLike(item[col.value])">
              <input type="checkbox" disabled :checked="toBoolean(item[col.value])" />
            </template>
            <template v-else>
              {{ formatCell(item[col.value], col.value) }}
            </template>
          </td>
          <td>
            <slot name="actions" :item="item">
              <button class="btn btn-xs btn-info icon-btn" @click="$emit('view', item)" title="Detalles">
                <vue-feather type="eye" />
              </button>
              <span class="mx-1"></span>
              <button class="btn btn-xs btn-warning icon-btn" @click="$emit('edit', item)" title="Editar">
                <vue-feather type="edit" />
              </button>
              <template v-if="showPolizasButton">
                <span class="mx-1"></span>
                <button class="btn btn-xs btn-primary icon-btn" :disabled="!hasRfc(item)"
                  :title="hasRfc(item) ? 'Ver pólizas' : 'Este contratante no tiene RFC'"
                  @click="$emit('polizas', item)">
                  <vue-feather type="folder" />
                </button>
              </template>
              <template v-if="showAccountButton">
                <span class="mx-1"></span>
                <button class="btn btn-xs btn-secondary icon-btn" @click="$router.push({ name: 'estadoCuenta', params: { id: item.id } })" title="Estado de cuenta">
                  <vue-feather type="file-text" />
                </button>
              </template>
              <!-- <span class="mx-1"></span>
              <button class="btn btn-xs btn-danger icon-btn" @click="$emit('delete', item)" aria-label="Eliminar" title="Eliminar">
                <vue-feather type="trash-2" />
              </button> -->
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    // rows: array of objects to render (should be already paginated by the parent)
    rows: { type: Array, default: () => [] },
    // columns: array of { text, value } describing which fields to render (order matters)
    columns: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: [String, null], default: null },
    // showAccountButton: whether to show the "Estado de cuenta" action (solo aplica a pólizas)
    showAccountButton: { type: Boolean, default: true },
    // showPolizasButton: muestra "Ver pólizas" (solo aplica a contratantes); emite `polizas` con la fila
    showPolizasButton: { type: Boolean, default: false },
  },
  emits: ['view', 'edit', 'delete', 'polizas'],
  methods: {
    hasRfc(item) {
      const rfc = item?.rfc ?? item?.RFC;
      return typeof rfc === 'string' && rfc.trim() !== '';
    },
    isBooleanLike(val) {
      if (typeof val === 'boolean') return true;
      if (typeof val === 'string') {
        const v = val.trim().toLowerCase();
        return v === 'true' || v === 'false';
      }
      return false;
    },
    toBoolean(val) {
      if (typeof val === 'boolean') return val;
      if (typeof val === 'string') return val.trim().toLowerCase() === 'true';
      return Boolean(val);
    },
    formatDateTime(val) {
      if (val == null) return '';
      let d;
      if (val instanceof Date) {
        d = val;
      } else if (this.isIsoDateString(String(val))) {
        d = new Date(val);
      } else {
        const parsed = Date.parse(val);
        if (!isNaN(parsed)) d = new Date(parsed);
        else return val;
      }

      if (isNaN(d)) return val;

      const pad = n => String(n).padStart(2, '0');
      const day = pad(d.getDate());
      const month = pad(d.getMonth() + 1);
      const year = String(d.getFullYear());
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      const seconds = pad(d.getSeconds());
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    isIsoDateString(val) {
      if (typeof val !== 'string') return false;
      const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?$/;
      const isoRegexNoT = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
      return isoRegex.test(val) || isoRegexNoT.test(val);
    },
    formatCell(val, key) {
      if (key && /(^id$|id$)/i.test(key)) {
        return val == null ? '' : String(val);
      }
      // no formatear poliza, producto ni status
      if (key && /^(poliza|producto|status)$/i.test(key)) {
        return val == null ? '' : String(val);
      }
      if (val && typeof val === 'number') return JSON.stringify(val);
      if (val && typeof val === 'object') return JSON.stringify(val);
      if (this.isIsoDateString(val) || (typeof val === 'number' && !Number.isNaN(val))) {
        const maybeDate = new Date(val);
        if (!isNaN(maybeDate)) return this.formatDateTime(maybeDate);
      }
      if (typeof val === 'string' && this.isIsoDateString(val)) {
        return this.formatDateTime(new Date(val));
      }
      return String(val);
    },
  },
};
</script>

<style scoped>
/* Center feather SVG icons inside small action buttons */
.icon-btn { width: 30px; height: 30px; padding: 0; display: inline-flex; align-items: center; justify-content: center; }
.icon-btn svg { width: 16px; height: 16px; stroke-width: 2; }
</style>
